<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div>
        <el-button type="text" @click="$router.push('/platform')"
          >人才币规则</el-button
        >
        <el-button type="text" @click="$router.push('/brokerage')"
          >代理规则</el-button
        >
        <el-button type="primary">会员</el-button>
        <el-button type="text" @click="$router.push('/rules')"
          >就业补贴</el-button
        >
        <el-button type="text" @click="$router.push('/companyrules')"
          >企业邀请规则</el-button
        >
      </div>
      <div>
        <el-switch
          @change="change(1)"
          v-model="value1"
          active-text="开启求职端苹果支付"
          inactive-text="关闭求职端苹果支付"
          :active-value="2"
          :inactive-value="1"
        >
        </el-switch>
        &nbsp;&nbsp;
        <el-switch
          @change="change(2)"
          v-model="value2"
          active-text="开启企业端苹果支付"
          inactive-text="关闭企业端苹果支付"
          :active-value="2"
          :inactive-value="1"
        >
        </el-switch>
      </div>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <div class="section shadow" style="padding: 10px 50px">
        <template>
          <p>会员费说明：</p>
          <p>
            1、用户需按天开通会员功能，会员有效期内可叠加开通，会员时长以24小时制累计，不支持退款
          </p>
          <p>2、若有修改金额，不影响之前已支付的诚信保证金或会员权限</p>
          <p>3、诚信保证金用户可申请全额免费退款</p>
        </template>
        <el-form
          ref="elFormDom"
          label-width="150px"
          label-position="right"
          :model="form.data"
          :rules="form.rules"
        >
          <el-row :gutter="40">
            <el-col :span="8">
              <el-form-item prop="honesty_earnest_amount" label="诚信保证金">
                <el-input
                  type="age"
                  v-model="form.data.honesty_earnest_amount"
                  placeholder="请输入诚信保证金"
                >
                  <span slot="suffix">元</span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item prop="day_vip_amount" label="会员费">
                <el-input
                  type="age"
                  style="width: 150px"
                  v-model="form.data.day_vip_amount"
                  placeholder="请输入会员费"
                >
                  <span slot="suffix">元/日</span>
                </el-input>
                <el-input
                  type="age"
                  style="width: 150px"
                  v-model="form.data.month_vip_amount"
                  placeholder="请输入会员费"
                >
                  <span slot="suffix">元/月</span>
                </el-input>
                <el-input
                  type="age"
                  style="width: 150px"
                  v-model="form.data.quarter_vip_amount"
                  placeholder="请输入会员费"
                >
                  <span slot="suffix">元/季</span>
                </el-input>
                <el-input
                  type="age"
                  style="width: 150px"
                  v-model="form.data.year_vip_amount"
                  placeholder="请输入会员费"
                >
                  <span slot="suffix">元/年</span>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <div style="display: flex">
              <el-form-item
                prop="perfect_resume_gift_vip"
                label="创建简历送会员"
              >
                <el-radio-group
                  v-model="form.data.perfect_resume_gift_vip"
                >
                  <el-radio :label="2">无赠送</el-radio>
                  <el-radio :label="1">赠送</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                prop="perfect_resume_gift_days"
                label="赠送天数"
                v-if="form.data.perfect_resume_gift_vip == 1"
              >
                <el-input
                  v-model="form.data.perfect_resume_gift_days"
                  placeholder="请输入"
                  style="width: 100px"
                  size="mini"
                  @input="handlePositiveInteger"
                >
                  <div slot="suffix">天</div>
                </el-input>
              </el-form-item>
            </div>
          </el-row>
        </el-form>
      </div>
      <div class="section shadow" style="padding: 20px; margin-top: 40px">
        <el-row type="flex" justify="center">
          <el-button @click="reset">重置</el-button>
          <el-button
            type="primary"
            :loading="form.loading"
            :disabled="form.loading"
            @click="confirm"
            >确定</el-button
          >
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
export default {
  name: "AgentList",
  components: {
    VTable,
  },
  data() {
    return {
      form: {
        loading: false,
        data: {
          vip_amount: "299", //日付会员奖励金额
          vip_fee: 1, //退费扣款
          day_vip_amount: "1", //日付会员奖励金额
          month_vip_amount:'',
          quarter_vip_amount:'',
          year_vip_amount:'',
          honesty_earnest_days: "1", //诚信保日期限制
          honesty_earnest_amount: "299", //诚信保缴纳金额
          perfect_resume_gift_vip: 1, //创建简历送会员
          perfect_resume_gift_days: 0,
        },
        rules: {
          honesty_earnest_amount: [
            { required: true, message: "诚信保证金不能为空" },
            // { type: "number", message: "会员费只能输入整数" },
          ],
          day_vip_amount: [
            { required: true, message: "会员费不能为空" },
            // { type: "number", message: "佣金比例只能输入整数" },
          ],
        },
      },
      value1: 1,
      value2: 1,
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    handlePositiveInteger() {
      // 只保留数字
      let val = this.form.data.perfect_resume_gift_days.replace(/[^0-9]/g, "");

      // 转数字并判断是否大于0
      val = Number(val);
      if (isNaN(val) || val <= 0) {
        this.form.data.perfect_resume_gift_days = "";
      } else {
        this.form.data.perfect_resume_gift_days = val;
      }
    },
    change(t) {
      this.$http
        .post("admin/config/applePay", {
          type: t,
          status: t == 1 ? this.value1 : this.value2,
        })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("设置成功");
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.form.loading = false;
        });
    },
    getTable() {
      this.$http.get("admin/config/get", { params: {} }).then((res) => {
        if (res.code === 1) {
          this.form.data = res.data;
          this.form.data.honesty_earnest_amount = Number(
            res.data.honesty_earnest_amount
          );
          this.form.data.day_vip_amount = Number(res.data.day_vip_amount);
          this.form.data.perfect_resume_gift_vip = Number(
            res.data.perfect_resume_gift_vip
          );
          this.form.data.perfect_resume_gift_days = Number(
            res.data.perfect_resume_gift_days
          );
          this.value1 = res.data.user_apple_status * 1;
          this.value2 = res.data.company_apple_status * 1;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          this.$http
            .post("admin/config/set", this.form.data)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("设置成功");
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
    reset() {
      this.$refs.elFormDom.resetFields();
    },
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
</style>